import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainNavComponent } from './main-nav/main-nav.component';
import { LoginComponent } from './login/login.component';
import { ErrorComponent } from './error/error.component';
import { LabelPrintPageComponent } from './label-print-page/label-print-page.component';
import { AssetNewPageComponent } from './asset-new-page/asset-new-page.component';
import { AssetListPageComponent } from './asset-list-page/asset-list-page.component';
import { PlaceListPageComponent } from './place-list-page/place-list-page.component';
import { ClassListPageComponent } from './class-list-page/class-list-page.component';
import { AuthGuard } from './helpers/auth.guard';
import { DashboardPageComponent } from './dashboard-page/dashboard-page.component';


const routes: Routes = [
  {
    path: '',
    component: MainNavComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      { path: 'label', component: LabelPrintPageComponent },
      { path: 'new', component: AssetNewPageComponent },
      { path: 'assets', component: AssetListPageComponent },
      { path: 'places', component: PlaceListPageComponent },
      { path: 'classes', component: ClassListPageComponent },
      { path: 'dashboard', component: DashboardPageComponent },
      // { path: 'assets', component: CategorySettingsComponent },
      // { path: 'places', component: SettingsComponent },
      // { path: 'classes', component: DataAcquisitionComponent },
    ]
  },
  { path: 'login', component: LoginComponent },
  { path: '**', component: ErrorComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
